import { Controller, FieldValues } from "react-hook-form";
import {
  fontWeightClass,
  getInputClass,
  getInputClassCustomized,
} from "~/assets/styles/classes/InputClasses";
import HighlightOffRoundedIcon from "@mui/icons-material/HighlightOffRounded";

interface SIMPLInputWithControllerProps {
  name: string;
  control: any;
  rows?:number
  rules?: Record<string, unknown>;
  id: string;
  label?: string;
  type?: string;
  fontWeight?: "bold" | "normal" | "extrabold";
  placeholder?: string;
  required?: boolean;
  errorLabel?: string;
  disabled?: boolean;
  hideLabel?: boolean;
  borderClass?:
    | "rounded-none"
    | "rounded-sm"
    | "rounded"
    | "rounded-md"
    | "rounded-lg"
    | "rounded-xl"
    | "rounded-2xl"
    | "rounded-3xl";
  onClick?: () => void;
  readOnly?: boolean;
  autoFocus?: boolean;
}

export const SIMPLInput = ({
  name,
  control,
  rules,
  id,
  label,
  fontWeight = "normal",
  type = "text",
  required = false,
  placeholder,
  errorLabel,
  disabled = false,
  hideLabel = false,
  borderClass = "rounded-lg",
  readOnly = false,
  rows,
  onClick,
  autoFocus = false,
}: SIMPLInputWithControllerProps) => {
  const getInputElement = (field: FieldValues) => {
    switch (type) {
      case "textarea":
        return (
          <textarea
            {...field}
            rows={rows}
            onClick={onClick}
            autoFocus={autoFocus}
            className={`${getInputClass(borderClass, errorLabel, readOnly)} resize-y min-h-10 max-h-44 h-full text-area-input placeholder:text-red-500`}
            id={id}
            readOnly={readOnly}
            placeholder={placeholder}
            disabled={disabled}
          />
        );
      default:
        return (
          <input
            {...field}
            type={type}
            onClick={onClick}
            autoFocus={autoFocus}
            className={`${getInputClassCustomized(borderClass, errorLabel, readOnly)} ${errorLabel ? "placeholder:text-[#CA3532]" : ""}`}
            id={id}
            readOnly={readOnly}
            placeholder={placeholder}
            disabled={disabled}
          />
        );
    }
  };

  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({ field }) => (
        <div>
          {!hideLabel && (
            <label
              htmlFor={id}
              className={`inline-block cursor-pointer text-sm ${fontWeightClass(fontWeight)} ${errorLabel ? "text-error" : ""}`}
            >
              {required && <span className="text-red-500">*</span>} {label}
            </label>
          )}
          <div className="relative flex flex-wrap items-stretch h-full">
            {getInputElement(field)}
          </div>
          {errorLabel && (
            <div className="flex items-center gap-1 mt-1 text-error">
              <HighlightOffRoundedIcon fontSize="small" />
              <span className="text-sm leading-[18px]">{errorLabel}</span>
            </div>
          )}
        </div>
      )}
    />
  );
};
